<!-- =========================================================
     Long Course Admin List
========================================================= -->

<section class="ecb-x-admin-list-section">
  <div class="container-fluid">
    <div class="ecb-x-admin-list-card">

      <!-- =====================================================
           Page Header
      ====================================================== -->
      <div class="ecb-x-admin-list-header">
        <div class="ecb-x-admin-list-title">
          <h1 class="fw-bold mb-1">Long Courses</h1>
          <p class="mb-0">
            Manage long course details, qualification information,
            categories, sessions, pricing and public content.
          </p>
        </div>

        <div class="ecb-x-admin-list-actions">
          <button type="button" class="ecb-x-admin-download-button" (click)="openDownloadDialog()">

            <i class="bi bi-file-earmark-excel"></i>
            Download Excel

          </button>
          <button type="button" class="ecb-x-admin-add-button" (click)="openNew()">
            <i class="bi bi-plus-lg"></i>
            Add Long Course
          </button>

          <!-- Search -->
          <div class="search_group">
            <div class="ecb-x-admin-search-wrapper">
              <i class="bi bi-search"></i>
              <input type="search" class="form-control" [(ngModel)]="catalogueSearch"
                (ngModelChange)="onCatalogueSearchChange()" placeholder="Search name or code"
                aria-label="Search long courses by name or code">
            </div>

            <button type="button" class="ecb-x-admin-add-button" (click)="onCatalogueSearchChange()">
              <i class="bi bi-search"></i>
            </button>
          </div>

          <!-- Start State Selection -->
          <div class="ecb-states-select-wrapper">



            <p-selectButton [options]="statesList" [(ngModel)]="selectedStateCode" optionLabel="siteName"
              optionValue="code" [multiple]="false" [allowEmpty]="false" (onChange)="onStateChange($event.value)"
              styleClass="ecb-states-select-button">
            </p-selectButton>

          </div>
          <!-- End State Selection -->


          <!-- Visibility Filter -->
          <div class="ecb-x-admin-filter-wrapper ecb-long-visibility-filter">
            <select class="form-select" [(ngModel)]="visibilityFilter" (change)="onCatalogueFilterChange()"
              aria-label="Filter by visibility">

              <option value="ALL">All Visibility</option>
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      <div class="editor-alert" role="alert" *ngIf="clusterLoadError">
        {{ clusterLoadError }}
      </div>

      <!-- =====================================================
           Long Course Table
      ====================================================== -->
      <div class="ecb-x-admin-table-container">
        <p-table [value]="paginatedAdminCourses" [loading]="isLoading" [scrollable]="true"
          [tableStyle]="{'min-width': '1180px'}" styleClass="ecb-admin-table">

          <ng-template pTemplate="header">
            <tr class="ecb-admin-table-header-row">
              <th class="ecb-admin-table-header ecb-col-image">IMAGE</th>
              <th class="ecb-admin-table-header ecb-col-code">CODE</th>
              <th class="ecb-admin-table-header ecb-col-course">COURSE</th>
              <th class="ecb-admin-table-header ecb-col-qualification">QUALIFICATION / CATEGORIES</th>
              <th class="ecb-admin-table-header ecb-col-price">PRICE</th>
              <th class="ecb-admin-table-header ecb-col-sessions">SESSIONS</th>
              <th class="ecb-admin-table-header ecb-col-status">STATUS</th>
              <th class="ecb-admin-table-header ecb-admin-table-action-header">ACTION</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-course>
            <tr class="ecb-admin-table-row">

              <!-- Image -->
              <td class="ecb-admin-table-cell">
                <div class="ecb-x-admin-table-image">
                  <img *ngIf="course.imageUrl" [src]="course.imageUrl" [alt]="course.courseName"
                    (error)="$any(course).imageUrl = ''">

                  <div class="ecb-x-admin-table-image-fallback" *ngIf="!course.imageUrl">
                    <i class="bi bi-mortarboard"></i>
                  </div>
                </div>
              </td>

              <!-- Code -->
              <td class="ecb-admin-table-cell">
                <span class="ecb-x-admin-course-code">
                  {{ course.courseCode || 'No code' }}
                </span>
              </td>

              <!-- Course -->
              <td class="ecb-admin-table-cell">
                <div class="ecb-x-admin-course-info">
                  <div class="ecb-x-admin-course-title">
                    {{ course.courseName || 'Untitled course' }}
                  </div>

                  <div class="ecb-x-admin-course-description">
                    {{ getAdminCourseDescription(course) }}
                  </div>
                </div>
              </td>

              <!-- Qualification / Categories -->
              <td class="ecb-admin-table-cell">
                <div class="ecb-long-qualification">
                  {{ course.qualificationType || 'No qualification type' }}
                </div>

                <div class="catalogue-tags">
                  <span *ngIf="!course.tags?.length">
                    {{ course.tagNames || 'No qualification' }}
                  </span>

                  <span *ngFor="let tag of course.tags">
                    {{ tag.tagName }}
                  </span>
                </div>
              </td>

              <!-- Price -->
              <td class="ecb-admin-table-cell">
                <span class="ecb-x-admin-price">
                  {{ getAdminCoursePrice(course) }}
                </span>
              </td>

              <!-- Sessions -->
              <td class="ecb-admin-table-cell">
                <span class="ecb-x-admin-calendar-badge"
                  [class.available]="(course.courseTimeCount || course.courseTimes?.length || 0) > 0"
                  [class.unavailable]="(course.courseTimeCount || course.courseTimes?.length || 0) === 0">

                  <i class="bi" [ngClass]="(course.courseTimeCount || course.courseTimes?.length || 0) > 0
                      ? 'bi-calendar-check'
                      : 'bi-calendar-x'">
                  </i>

                  {{ (course.courseTimeCount || course.courseTimes?.length || 0) > 0
                  ? ((course.courseTimeCount || course.courseTimes?.length || 0) + ' Session' +
                  ((course.courseTimeCount || course.courseTimes?.length || 0) === 1 ? '' : 's'))
                  : 'No Sessions' }}
                </span>
              </td>

              <!-- Status -->
              <td class="ecb-admin-table-cell">
                <span class="ecb-x-admin-status-badge" [class.active]="course.isActive"
                  [class.inactive]="!course.isActive">

                  {{ course.isActive ? 'Active' : 'Inactive' }}
                </span>
              </td>

              <!-- Actions -->
              <td class="ecb-admin-table-cell ecb-admin-table-action-cell">
                <button type="button" class="ecb-admin-table-action-button ecb-admin-table-edit-button"
                  (click)="edit(course)" [attr.aria-label]="'Edit ' + course.courseName" title="Edit course">

                  <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>
                </button>

                <button type="button" class="ecb-admin-table-action-button ecb-admin-table-delete-button"
                  (click)="requestDelete(course)" [attr.aria-label]="'Delete ' + course.courseName"
                  title="Delete course">

                  <i class="bi bi-trash3 ecb-admin-table-action-icon"></i>
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr class="ecb-admin-table-row">
              <td colspan="8" class="ecb-admin-table-cell">
                <div class="ecb-x-admin-table-empty">
                  <div class="ecb-x-admin-empty-icon">
                    <i class="bi bi-journal-x"></i>
                  </div>

                  <h3>No Courses Available</h3>
                  <p>Try another search/filter or add a new long course.</p>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="loadingbody">
            <tr class="ecb-admin-table-row">
              <td colspan="8" class="ecb-admin-table-cell">
                <div class="ecb-x-admin-table-loading">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                  <span>Loading courses...</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

       <!-- =====================================================
     SERVER-SIDE PAGINATION
====================================================== -->

<div class="ecb-short-pagination" *ngIf="totalRecords > 0">

  <div class="ecb-short-pagination-summary">
    Showing {{ pageStart }}-{{ pageEnd }}
    of {{ totalRecords }} courses
  </div>

  <div class="ecb-short-page-size">

    <label for="longCoursePageSize">
      Rows per page
    </label>

    <select
      id="longCoursePageSize"
      [value]="pageSize"
      (change)="changePageSize($any($event.target).value)">

      <option
        *ngFor="let option of pageSizeOptions"
        [value]="option">
        {{ option }}
      </option>

    </select>

  </div>

  <div class="ecb-short-page-controls">

    <!-- Previous -->
    <button
      type="button"
      (click)="changePage(currentPage - 1)"
      [disabled]="currentPage === 1 || isLoading">
      Previous
    </button>

    <!-- Page numbers -->
    <button
      type="button"
      *ngFor="let page of pageNumbers"
      [class.active]="page === currentPage"
      [disabled]="isLoading"
      (click)="changePage(page)">
      {{ page }}
    </button>

    <!-- Next -->
    <button
      type="button"
      (click)="changePage(currentPage + 1)"
      [disabled]="currentPage >= totalPages || isLoading">
      Next
    </button>

  </div>

</div>
      </div>
    </div>
  </div>
</section>

<!-- Start p-dialog -->
<p-dialog [(visible)]="showDialog" [modal]="true" [style]="{width:'1120px', maxWidth:'96vw'}" [draggable]="false"
  [resizable]="false" styleClass="admin-course-dialog" [closable]="!isSaving" [closeOnEscape]="!isSaving">
  <!-- Start ng-template -->
  <ng-template pTemplate="header">
    <!-- Start editor-dialog-heading div -->
    <div class="editor-dialog-heading">
      <!-- Start editor-symbol span -->
      <span class="editor-symbol">
        <!-- Start fa i -->
        <i class="fa" [ngClass]="editor.isCluster ? 'fa-cubes' : 'fa-graduation-cap'" aria-hidden="true">
        </i>
        <!-- End fa i -->
      </span>
      <!-- End editor-symbol span -->
      <!-- Start div -->
      <div>
        <!-- Start page-eyebrow span -->
        <span class="page-eyebrow">{{ editor.courseId ? 'EDIT COURSE' : 'NEW COURSE' }}</span>
        <!-- End page-eyebrow span -->
        <!-- Start h2 -->
        <h2>{{ editor.courseName || 'Course details' }}</h2>
        <!-- End h2 -->
        <!-- Start p -->
        <p>Set up your content, pricing and training availability.</p>
        <!-- End p -->
      </div>
      <!-- End div -->
    </div>
    <!-- End editor-dialog-heading div -->
  </ng-template>
  <!-- End ng-template -->
  <!-- Start editor-tabs nav -->
  <nav class="editor-tabs" aria-label="Course editor sections">
    <!-- Start button -->
    <button type="button" [class.current]="editorTab === 'details'"
      [attr.aria-current]="editorTab === 'details' ? 'step' : null" (click)="editorTab = 'details'">
      <!-- Start span -->
      <span>01</span>
      <!-- End span -->
      Course details
    </button>
    <!-- End button -->
    <!-- Start button -->
    <button type="button" [class.current]="editorTab === 'pricing'"
      [attr.aria-current]="editorTab === 'pricing' ? 'step' : null" (click)="editorTab = 'pricing'">
      <!-- Start span -->
      <span>02</span>
      <!-- End span -->
      Units & pricing
    </button>
    <!-- End button -->
    <!-- Start button -->
    <button type="button" [class.current]="editorTab === 'content'"
      [attr.aria-current]="editorTab === 'content' ? 'step' : null" (click)="editorTab = 'content'">
      <!-- Start span -->
      <span>03</span>
      <!-- End span -->
      Content & files
    </button>
    <!-- End button -->
    <!-- Start button -->
    <button type="button" [class.current]="editorTab === 'outcomes'"
      [attr.aria-current]="editorTab === 'outcomes' ? 'step' : null" (click)="editorTab = 'outcomes'">
      <!-- Start span -->
      <span>04</span>
      <!-- End span -->
      Outcomes & study
    </button>
    <!-- End button -->
    <!-- Start button -->
    <button type="button" [class.current]="editorTab === 'sessions'"
      [attr.aria-current]="editorTab === 'sessions' ? 'step' : null" (click)="editorTab = 'sessions'">
      <!-- Start span -->
      <span>05</span>
      <!-- End span -->
      Sessions
    </button>
    <!-- End button -->
  </nav>
  <!-- End editor-tabs nav -->
  <!-- Start editor-body div -->
  <div class="editor-body">
    <!-- Start editor-alert div -->
    <div class="editor-alert" role="alert" *ngIf="errorList.length">
      <!-- Start strong -->
      <strong>Please check the following</strong>
      <!-- End strong -->
      <!-- Start div -->
      <div *ngFor="let error of errorList">{{ error.ErrorMessage }}</div>
      <!-- End div -->
    </div>
    <!-- End editor-alert div -->
    <!-- Start editor-section section -->
    <section *ngIf="editorTab === 'details'" class="editor-section">
      <!-- Start section-heading div -->
      <div class="section-heading">
        <div class="row">
          <div class="col-8">
            <!-- Start h3 -->
            <h3>Course information</h3>
            <!-- End h3 -->
            <!-- Start p -->
            <p>The essentials customers see when browsing your catalogue.</p>
            <!-- End p -->
          </div>
          <div class="col-2">

          </div>
          <div class="col-2">

            <!-- Start State Selection -->
            <div class="ecb-states-select-wrapper">

              <label class="ecb-states-select-label">Location</label>

              <p-selectButton [options]="statesList" [(ngModel)]="selectedFormStateCode" optionLabel="siteName"
                optionValue="code" [multiple]="false" [allowEmpty]="false" (onChange)="onFormStateChange($event.value)"
                styleClass="ecb-states-select-button">
              </p-selectButton>

            </div>
            <!-- End State Selection -->
          </div>
        </div>
      </div>
      <!-- End section-heading div -->
      <!-- Start course-type-choice div -->
      <div class="course-type-choice" *ngIf="false">
        <!-- Start button -->
        <button type="button" [class.selected]="!editor.isCluster" [attr.aria-pressed]="!editor.isCluster"
          (click)="setCourseType(false)">
          <!-- Start fa i -->
          <i class="fa fa-file-text-o" aria-hidden="true">
          </i>
          <!-- End fa i -->
          <!-- Start span -->
          <span>
            <!-- Start strong -->
            <strong>Individual course</strong>
            <!-- End strong -->
            <!-- Start small -->
            <small>
              {{ editor.courseId ?
              'Use the same course record as an individual course' : 'A standalone course at its standard price' }}
            </small>
            <!-- End small -->
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa" [ngClass]="!editor.isCluster ? 'fa-check-circle' : 'fa-circle-o'" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End button -->
        <!-- Start button -->
        <button *ngIf="false" type="button" [class.selected]="editor.isCluster" [attr.aria-pressed]="!!editor.isCluster"
          (click)="setCourseType(true)">
          <!-- Start fa i -->
          <i class="fa fa-cubes" aria-hidden="true">
          </i>
          <!-- End fa i -->
          <!-- Start span -->
          <span>
            <!-- Start strong -->
            <strong>Training cluster</strong>
            <!-- End strong -->
            <!-- Start small -->
            <small>
              {{ editor.courseId ?
              'Convert this same course into a linked-course cluster' : 'Linked courses with a combined discount' }}
            </small>
            <!-- End small -->
          </span>
          <!-- End span -->
          <!-- Start fa i -->
          <i class="fa" [ngClass]="editor.isCluster ? 'fa-check-circle' : 'fa-circle-o'" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End button -->
      </div>
      <!-- End course-type-choice div -->

      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action categories-heading">
        <!-- Start div -->
        <div class="field-grid">
          <div>
            <!-- Start h3 -->
            <label>
              Course qualifications
              <!-- Start required span -->
              <span class="required">*</span>
              <!-- End required span -->
            </label>
            <!-- End h3 -->
            <!-- Start p -->
            <p>Choose where this course appears in the public catalogue.</p>
            <!-- End p -->
          </div>
        </div>
        <!-- End div -->
        <!-- Start text-button button -->
        <button type="button" class="text-button" (click)="goToTags()">
          Manage qualifications
          <!-- Start fa i -->
          <i class="fa fa-angle-right" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End text-button button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start tag-check-grid div -->
      <div class="tag-check-grid">
        <!-- Start tag-check label -->
        <label class="tag-check" [class.selected]="isTagSelected(tag.tagId)" *ngFor="let tag of tags">
          <!-- Start input -->
          <input type="checkbox" [checked]="isTagSelected(tag.tagId)"
            (change)="toggleTag(tag.tagId, $any($event.target).checked)">
          <!-- End input -->
          <!-- Start span -->
          <span style="display: flex; align-items: center;">
            {{ tag.tagName }}
            <!-- Start small -->
            <small *ngIf="false" style="padding-left: 5px;"> ({{ tag.slug }})</small>
            <!-- End small -->
          </span>
          <!-- End span -->
        </label>
        <!-- End tag-check label -->
      </div>
      <!-- End tag-check-grid div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!tags.length">No categories yet. Create a category before saving this course.
      </div>
      <!-- End empty-panel div -->

      <!-- Start field-grid div -->
      <div class="field-grid" style="margin-top: 5px;">
        <!-- Start label -->
        <label>
          Course code
          <span class="required">*</span>
          <!-- Course code is created once and cannot be changed afterwards. -->
          <input [(ngModel)]="editor.courseCode" placeholder="e.g. CHC33021" maxlength="80"
            [readonly]="!!editor.courseId" [class.readonly-field]="!!editor.courseId"
            [class.field-invalid]="CheckErrorCode('CODE_EMPTY') || CheckErrorCode('CODE_DUPLICATE')">
          <small *ngIf="editor.courseId">Course code cannot be changed after the course has been created.</small>
        </label>
        <!-- End label -->
        <!-- Start label -->
        <label>
          Certificate level
          <span class="required" *ngIf="!editor.courseId">*</span>
          <!-- Start select -->
          <select [(ngModel)]="editor.qualificationType" aria-label="Certificate level">
            <!-- Start option -->
            <option value="" disabled>Select certificate level</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="None">No Certificate</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Course">Course</option>
            <!-- End option -->

            <!-- Start option -->
            <option value="Certificate I">Certificate I</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Certificate II">Certificate II</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Certificate III">Certificate III</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Certificate IV">Certificate IV</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Diploma">Diploma</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Advanced Diploma">Advanced Diploma</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Skill Set">Skill Set</option>
            <!-- End option -->
            <!-- Start option -->
            <option value="Short Course">Short Course</option>
            <!-- End option -->
          </select>
          <!-- End select -->
          <!-- Start small -->
          <small>Matches the certificate level used by VICSEG New Futures, e.g. Certificate III or Certificate
            IV.</small>
          <!-- End small -->
        </label>
        <!-- End label -->
        <!-- Start full-width label -->
        <label class="full-width">
          Course name
          <!-- Start required span -->
          <span class="required">*</span>
          <!-- End required span -->
          <!-- Start input -->
          <input [(ngModel)]="editor.courseName" placeholder="e.g. Individual Support (Ageing and Disability)"
            [class.field-invalid]="CheckErrorCode('NAME_EMPTY')">
          <!-- End input -->
          <!-- Start small -->
          <small>You may enter only the subject name. The qualification type is automatically prefixed on the public
            course title and is not duplicated if already present.</small>
          <!-- End small -->
        </label>
        <!-- End full-width label -->
        <!-- Start full-width label -->
        <div class="full-width">
          <label class="field-label">
            Short description
            <span class="required" *ngIf="editor.courseId">*</span>
          </label>
          <div [class.editor-field-invalid]="CheckErrorCode('DESCRIPTION_REQUIRED')">
            <p-editor [(ngModel)]="editor.shortDescription" [modules]="editorModules"
              placeholder="A brief introduction to the course and who it is for." [style]="{height:'150px'}">
            </p-editor>
          </div>
          <!-- <p-editor [(ngModel)]="editor.shortDescription" [style]="{height:'150px'}"
              placeholder="A brief introduction to the course and who it is for.">
              <ng-template pTemplate="header">
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                </span>
                <span class="ql-formats">
                  <button type="button" class="ql-list" value="ordered" aria-label="Numbered list"></button>
                  <button type="button" class="ql-list" value="bullet" aria-label="Bullet list"></button>
                </span>
                <span class="ql-formats">
                  <button type="button" class="ql-link" aria-label="Insert hyperlink"></button>
                  <button type="button" class="ql-clean" aria-label="Clear formatting"></button>
                </span>
              </ng-template>
            </p-editor> -->
          <small>Appears on course cards and at the top of the details page. Hyperlinks are supported.</small>
        </div>
        <!-- End full-width label -->
        <!-- Start label -->
        <label>
          Default location
          <!-- Start input -->
          <input [(ngModel)]="editor.locationName" placeholder="Training location">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start label -->
        <label>
          Minimum placement hours
          <!-- Start input -->
          <input type="number" min="0" step="1" [(ngModel)]="editor.placementHours" placeholder="e.g. 120">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start full-width label -->
        <label class="full-width">
          Pathways introduction
          <!-- Start textarea -->
          <textarea rows="2" [(ngModel)]="editor.pathwaysIntroduction" maxlength="2000"
            placeholder="e.g. Continue your learning journey and build a career in the care industry.">
            </textarea>
          <!-- End textarea -->
        </label>
        <!-- End full-width label -->
        <!-- Start full-width label -->
        <label class="full-width">
          Pathways information note
          <!-- Start textarea -->
          <textarea rows="2" [(ngModel)]="editor.pathwaysNote" maxlength="2000"
            placeholder="Text shown in the blue information box below pathway links">
            </textarea>
          <!-- End textarea -->
        </label>
        <!-- End full-width label -->
      </div>
      <!-- End field-grid div -->
      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action content-section-heading">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Delivery mode options</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Add each delivery method as a separate line in the public summary card.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addDeliveryOption()">
          <!-- Start fa i -->
          <i class="fa fa-plus">
          </i>
          <!-- End fa i -->
          Add option
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.deliveryOptions?.length">No delivery modes added yet. Add each mode
        exactly as it should appear on the public course page.</div>
      <!-- End empty-panel div -->
      <!-- Start content-list-row div -->
      <div class="content-list-row" *ngFor="let option of editor.deliveryOptions; let i = index; trackBy: trackByIndex">
        <!-- Start label -->
        <label>
          Delivery option {{ i + 1 }}
          <!-- Start input -->
          <input [(ngModel)]="editor.deliveryOptions[i]" maxlength="200" placeholder="e.g. Online classroom">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start icon-button button -->
        <button type="button" class="icon-button danger" (click)="removeDeliveryOption(i)"
          [attr.aria-label]="'Remove delivery option ' + (i + 1)">
          <!-- Start fa i -->
          <i class="fa fa-trash-o">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End icon-button button -->
      </div>
      <!-- End content-list-row div -->
      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action content-section-heading">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Duration options</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Add each duration row separately, for example Classroom — 9 - 12 months and Flexible — 7 - 10 months.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addDurationOption()">
          <!-- Start fa i -->
          <i class="fa fa-plus">
          </i>
          <!-- End fa i -->
          Add duration
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.durationOptions?.length">No duration rows added yet.</div>
      <!-- End empty-panel div -->
      <!-- Start content-list-row div -->
      <div class="content-list-row pathway-row"
        *ngFor="let item of editor.durationOptions; let i = index; trackBy: trackByIndex">
        <!-- Start label -->
        <label>
          Label
          <!-- Start input -->
          <input [(ngModel)]="item.label" maxlength="100" placeholder="e.g. Classroom">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start label -->
        <label>
          Duration
          <!-- Start input -->
          <input [(ngModel)]="item.duration" maxlength="200" placeholder="e.g. 9 - 12 months">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start icon-button button -->
        <button type="button" class="icon-button danger" (click)="removeDurationOption(i)"
          [attr.aria-label]="'Remove duration ' + (i + 1)">
          <!-- Start fa i -->
          <i class="fa fa-trash-o">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End icon-button button -->
      </div>
      <!-- End content-list-row div -->
      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action content-section-heading">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Course prerequisites</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Optional. If empty, the public About This Course panel automatically expands to full width.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addPrerequisite()">
          <!-- Start fa i -->
          <i class="fa fa-plus">
          </i>
          <!-- End fa i -->
          Add prerequisite
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.coursePrerequisites?.length">No course prerequisites. The prerequisite
        panel will remain hidden.</div>
      <!-- End empty-panel div -->
      <!-- Start content-list-row div -->
      <div class="content-list-row"
        *ngFor="let prerequisite of editor.coursePrerequisites; let i = index; trackBy: trackByIndex">
        <!-- Start label -->
        <label>
          Prerequisite {{ i + 1 }}
          <!-- Start input -->
          <input [(ngModel)]="editor.coursePrerequisites[i]" maxlength="300"
            placeholder="e.g. Basic English language skills">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start icon-button button -->
        <button type="button" class="icon-button danger" (click)="removePrerequisite(i)"
          [attr.aria-label]="'Remove prerequisite ' + (i + 1)">
          <!-- Start fa i -->
          <i class="fa fa-trash-o">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End icon-button button -->
      </div>
      <!-- End content-list-row div -->
      <!-- Start field-grid div -->
      <div class="field-grid">
        <!-- Start label -->
        <label>
          Enrolment closing date
          <!-- Start input -->
          <input type="date" [(ngModel)]="editor.startDate">
          <!-- End input -->
        </label>
        <!-- End label -->
        <!-- Start label -->
        <label>
          Visibility
          <!-- Start select -->
          <select [(ngModel)]="editor.isActive">
            <!-- Start option -->
            <option [ngValue]="true">Active — available to customers</option>
            <!-- End option -->
            <!-- Start option -->
            <option [ngValue]="false">Inactive — hidden from customers</option>
            <!-- End option -->
          </select>
          <!-- End select -->
        </label>
        <!-- End label -->
      </div>
      <!-- End field-grid div -->
    </section>
    <!-- End editor-section section -->
    <!-- Start editor-section section -->
    <section *ngIf="editorTab === 'pricing'" class="editor-section">
      <!-- Start section-heading div -->
      <div class="section-heading">
        <!-- Start h3 -->
        <h3>{{ editor.isCluster ? 'Build your training cluster' : 'Course pricing & units' }}</h3>
        <!-- End h3 -->
        <!-- Start p -->
        <p>
          {{ editor.isCluster ?
          'Choose the linked courses, then set a lower price for booking them together.' :
          'Set the standard price and list the units included in this course.' }}
        </p>
        <!-- End p -->
      </div>
      <!-- End section-heading div -->
      <!-- Start pricing-layout div -->
      <div class="pricing-layout">
        <!-- Start div -->
        <div>
          <!-- Start field-grid div -->
          <div class="field-grid price-fields">
            <!-- Start label -->
            <label>
              Currency

              <input [(ngModel)]="editor.currencyCode" maxlength="5" placeholder="AUD">
              <!-- End input -->
            </label>
            <!-- End label -->
            <!-- Start label -->
            <label>
              {{ editor.isCluster ? 'Cluster price' : 'Individual price' }}
              <!-- Optional field -->
              <!-- Start input -->
              <input type="number" min="0" step="0.01" [(ngModel)]="editor.price">
              <!-- End input -->
              <!-- Start small -->
              <small>Excluding GST</small>
              <!-- End small -->
            </label>
            <!-- End label -->
          </div>
          <!-- End field-grid div -->
          <!-- Start ng-container -->
          <ng-container *ngIf="editor.isCluster">
            <!-- Start cluster-conversion-note div -->
            <div class="cluster-conversion-note" *ngIf="editor.courseId">
              <!-- Start fa i -->
              <i class="fa fa-info-circle" aria-hidden="true">
              </i>
              <!-- End fa i -->
              <!-- Start div -->
              <div>
                <!-- Start strong -->
                <strong>Existing course values are preserved</strong>
                <!-- End strong -->
                <!-- Start span -->
                <span>Changing this course to a cluster keeps its current content, units, sessions, categories,
                  qualification and other details. Select linked courses below and save to update the same
                  CourseId.</span>
                <!-- End span -->
              </div>
              <!-- End div -->
            </div>
            <!-- End cluster-conversion-note div -->
            <!-- Start field-grid div -->
            <div class="field-grid" *ngIf="canChooseClusterAnchor">
              <!-- Start full-width label -->
              <label class="full-width">
                Current course
                <!-- Optional legacy cluster control -->
                <!-- Start select -->
                <select [ngModel]="editor.clusterAnchorCourseId" (ngModelChange)="selectClusterAnchor($event)">
                  <!-- Start option -->
                  <option [ngValue]="undefined" disabled>Select the course for this discount</option>
                  <!-- End option -->
                  <!-- Start option -->
                  <option *ngFor="let unit of allClusterCandidates" [ngValue]="unit.courseId"
                    [disabled]="!unit.isActive || unit.currencyCode !== editor.currencyCode">{{ unit.courseName }} —
                    {{ courseCategoryNames(unit).join(', ') }}</option>
                  <!-- End option -->
                </select>
                <!-- End select -->
              </label>
              <!-- End full-width label -->
            </div>
            <!-- End field-grid div -->
            <!-- Start unit-selector-heading div -->
            <div class="unit-selector-heading">
              <!-- Start h4 -->
              <h4>Select linked courses</h4>
              <!-- End h4 -->
              <!-- Start span -->
              <span>{{ (editor.clusterCourseIds?.length || 0) + (editor.courseId ? 1 : 0) }} selected</span>
              <!-- End span -->
            </div>
            <!-- End unit-selector-heading div -->
            <!-- Start selector-help p -->
            <p class="selector-help">
              {{ editor.courseId ?
              'The current course is always included. Select at least one more individual course.' :
              'The current course stays selected. Choose at least one additional course from any category.' }}
            </p>
            <!-- End selector-help p -->
            <!-- Start catalogue-search div -->
            <div class="catalogue-search">
              <!-- Start fa i -->
              <i class="fa fa-search" aria-hidden="true">
              </i>
              <!-- End fa i -->
              <!-- Start input -->
              <input [(ngModel)]="clusterSearch" placeholder="Search code, name or category"
                aria-label="Search cluster units across all categories">
              <!-- End input -->
            </div>
            <!-- End catalogue-search div -->
            <!-- Start cluster-unit-options div -->
            <div class="cluster-unit-options">
              <!-- Start cluster-unit-option label -->
              <label class="cluster-unit-option" *ngFor="let unit of clusterCandidates"
                [class.checked]="isClusterUnitSelected(unit.courseId)"
                [class.required-course]="isClusterAnchor(unit.courseId)">
                <!-- Start input -->
                <input type="checkbox" [checked]="isClusterUnitSelected(unit.courseId)"
                  [disabled]="isClusterAnchor(unit.courseId) || ((!unit.isActive || unit.currencyCode !== editor.currencyCode) && !isClusterUnitSelected(unit.courseId))"
                  (change)="toggleClusterUnit(unit.courseId, $any($event.target).checked)">
                <!-- End input -->
                <!-- Start span -->
                <span>
                  <!-- Start small -->
                  <small>{{ unit.courseCode }}</small>
                  <!-- End small -->
                  <!-- Start strong -->
                  <strong>{{ unit.courseName }}</strong>
                  <!-- End strong -->
                  <!-- Start unit-categories span -->
                  <span class="unit-categories">
                    <!-- Start span -->
                    <span *ngFor="let category of courseCategoryNames(unit)">{{ category }}</span>
                    <!-- End span -->
                  </span>
                  <!-- End unit-categories span -->
                  <!-- Start required-course-label small -->
                  <small class="required-course-label" *ngIf="isClusterAnchor(unit.courseId)">
                    <!-- Start fa i -->
                    <i class="fa fa-lock" aria-hidden="true">
                    </i>
                    <!-- End fa i -->
                    Current course · always included
                  </small>
                  <!-- End required-course-label small -->
                  <!-- Start em -->
                  <em *ngIf="!unit.isActive || unit.currencyCode !== editor.currencyCode">{{ !unit.isActive ?
                    'Inactive course' : 'Different currency' }}</em>
                  <!-- End em -->
                </span>
                <!-- End span -->
                <!-- Start b -->
                <b>{{ unit.price | currency:unit.currencyCode:'symbol':'1.2-2' }}</b>
                <!-- End b -->
              </label>
              <!-- End cluster-unit-option label -->
            </div>
            <!-- End cluster-unit-options div -->
            <!-- Start empty-panel div -->
            <div class="empty-panel" *ngIf="!clusterCandidates.length">No matching individual courses. Change your
              search or create an individual course first.</div>
            <!-- End empty-panel div -->
            <!-- Start selector-footer div -->
            <div class="selector-footer">
              <!-- Start small -->
              <small>Select at least two active courses in the same currency.</small>
              <!-- End small -->
              <!-- Start text-button button -->
              <button type="button" class="text-button" (click)="clearClusterSelection()">Clear additional
                courses</button>
              <!-- End text-button button -->
            </div>
            <!-- End selector-footer div -->
          </ng-container>
          <!-- End ng-container -->
          <!-- Start preserved-values-panel div -->
          <div class="preserved-values-panel">
            <!-- Start preserved-values-heading div -->
            <div class="preserved-values-heading">
              <!-- Start div -->
              <div>
                <!-- Start h4 -->
                <h4>Existing course values</h4>
                <!-- End h4 -->
                <!-- Start p -->
                <p>These values remain attached to this same course when switching between Individual and Training
                  Cluster.</p>
                <!-- End p -->
              </div>
              <!-- End div -->
              <!-- Start text-button button -->
              <button type="button" class="text-button" (click)="editorTab = 'outcomes'">Review content</button>
              <!-- End text-button button -->
            </div>
            <!-- End preserved-values-heading div -->
            <!-- Start preserved-value-grid div -->
            <div class="preserved-value-grid">
              <!-- Start div -->
              <div>
                <!-- Start span -->
                <span>Study units</span>
                <!-- End span -->
                <!-- Start strong -->
                <strong>{{ editor.courseUnits?.length || 0 }}</strong>
                <!-- End strong -->
              </div>
              <!-- End div -->
              <!-- Start div -->
              <div>
                <!-- Start span -->
                <span>Career outcomes</span>
                <!-- End span -->
                <!-- Start strong -->
                <strong>{{ editor.employmentOutcomes?.length || 0 }}</strong>
                <!-- End strong -->
              </div>
              <!-- End div -->
              <!-- Start div -->
              <div>
                <!-- Start span -->
                <span>Study pathways</span>
                <!-- End span -->
                <!-- Start strong -->
                <strong>{{ editor.studyPathways?.length || 0 }}</strong>
                <!-- End strong -->
              </div>
              <!-- End div -->
              <!-- Start div -->
              <div>
                <!-- Start span -->
                <span>Sessions</span>
                <!-- End span -->
                <!-- Start strong -->
                <strong>{{ editor.courseTimes?.length || 0 }}</strong>
                <!-- End strong -->
              </div>
              <!-- End div -->
            </div>
            <!-- End preserved-value-grid div -->
          </div>
          <!-- End preserved-values-panel div -->
        </div>
        <!-- End div -->
        <!-- Start pricing-preview aside -->
        <aside class="pricing-preview">
          <!-- Start page-eyebrow span -->
          <span class="page-eyebrow">PRICING PREVIEW</span>
          <!-- End page-eyebrow span -->
          <!-- Start h3 -->
          <h3>{{ editor.isCluster ? 'The complete cluster' : 'Individual course' }}</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>
            {{ editor.isCluster ?
            'Customers can book the complete cluster or choose units individually.' :
            'The standard price customers pay for this course.' }}
          </p>
          <!-- End p -->
          <!-- Start ng-container -->
          <ng-container *ngIf="editor.isCluster">
            <!-- Start preview-unit div -->
            <div class="preview-unit" *ngFor="let unit of clusterPreview.clusterCourses">

              <span>
                <small *ngIf="unit.courseCode">
                  {{ unit.courseCode }}
                </small>

                {{ unit.courseName }}
              </span>

              <strong>
                {{ editor.currencyCode }} {{ unit.price | number:'1.2-2' }}
              </strong>
            </div>

            <div class="preview-line">
              <span>Normal total</span>

              <s>
                {{ editor.currencyCode }} {{ clusterNormalPrice | number:'1.2-2' }}
              </s>
            </div>
            <!-- End preview-unit div -->
            <!-- Start preview-line div -->
            <div class="preview-line">
              <!-- Start span -->
              <span>Normal total</span>
              <!-- End span -->
              <!-- Start s -->
              <s>{{ clusterNormalPrice | currency:editor.currencyCode:'symbol':'1.2-2' }}</s>
              <!-- End s -->
            </div>
            <!-- End preview-line div -->
          </ng-container>
          <!-- End ng-container -->
          <!-- Start preview-price div -->
          <div class="preview-price">
            <!-- Start span -->
            <span>{{ editor.isCluster ? 'Cluster price' : 'Course price' }}</span>
            <!-- End span -->
            <!-- Start strong -->
            <strong>{{ editor.currencyCode }} {{ editor.price | number:'1.2-2' }}</strong>
            <!-- End strong -->
          </div>
          <!-- End preview-price div -->
          <!-- Start preview-saving div -->
          <div class="preview-saving" *ngIf="editor.isCluster && !clusterError">
            <!-- Start fa i -->
            <i class="fa fa-check-circle" aria-hidden="true">
            </i>
            <!-- End fa i -->
            Customer saves
            {{ editor.currencyCode }}
            {{ (clusterNormalPrice - editor.price) | number:'1.2-2' }}
          </div>
          <!-- End preview-saving div -->
          <!-- Start validation-note p -->
          <p class="validation-note" *ngIf="editor.isCluster && clusterError">{{ clusterError }}</p>
          <!-- End validation-note p -->
          <!-- Start small -->
          <small>All prices exclude GST.</small>
          <!-- End small -->
        </aside>
        <!-- End pricing-preview aside -->
      </div>
      <!-- End pricing-layout div -->
    </section>
    <!-- End editor-section section -->
    <!-- Start editor-section section -->
    <section *ngIf="editorTab === 'content'" class="editor-section">
      <!-- Start section-heading div -->
      <div class="section-heading">
        <!-- Start h3 -->
        <h3>Course content & files</h3>
        <!-- End h3 -->
        <!-- Start p -->
        <p>Give customers a clear overview and supporting information.</p>
        <!-- End p -->
      </div>
      <!-- End section-heading div -->
      <!-- Start field-label label -->
      <label class="field-label">Full description</label>
      <!-- End field-label label -->
      <!-- Start p-editor -->
      <p-editor [(ngModel)]="editor.fullDescription" [modules]="editorModules"
        placeholder="Describe the course, outcomes, requirements and delivery..." [style]="{height:'150px'}">
      </p-editor>
      <!-- End p-editor -->
      <!-- Start upload-grid div -->

      <div class="upload-grid">

        <!-- Start Course Image Upload -->
        <div class="upload-panel">

          <app-common-upload label="Course Image" mode="single" folderName="course-images"
            accept=".jpg,.jpeg,.png,.webp, .bmp" [maxFileSizeMB]="5" [maxOriginalFileSizeMB]="30" [compressImages]="true"
            [imageQuality]="0.8" [maxImageWidth]="1600" [maxImageHeight]="1600" [(imageUrl)]="editor.imageUrl"
            (uploadError)="onCourseImageUploadError($event)"></app-common-upload>

          <small>Used on the course card and details page.</small>

        </div>
        <!-- End Course Image Upload -->


        <!-- Start Course Brochure - Existing Code -->
        <label class="upload-panel">

          <span>
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
            <strong>Course brochure</strong>
          </span>

          <small>
            Upload a PDF for the Download Brochure button.
          </small>

          <input type="file" accept=".pdf,application/pdf" (change)="uploadBrochure($event)">

          <input class="content-url" [(ngModel)]="editor.brochureUrl" placeholder="Brochure URL"
            aria-label="Brochure URL">

          <a *ngIf="editor.brochureUrl" [href]="editor.brochureUrl" target="_blank" rel="noopener noreferrer">
            View uploaded brochure
            <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>

        </label>
        <!-- End Course Brochure -->

      </div>

      <!-- End upload-grid div -->
    </section>
    <!-- End editor-section section -->
    <!-- Start editor-section section -->
    <section *ngIf="editorTab === 'outcomes'" class="editor-section">
      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Employment outcomes</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Add the job roles this course can prepare students for.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addOutcome()">
          <!-- Start fa i -->
          <i class="fa fa-plus" aria-hidden="true">
          </i>
          <!-- End fa i -->
          Add outcome
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.employmentOutcomes?.length">No outcomes added. This section stays hidden
        until content is provided.</div>
      <!-- End empty-panel div -->
      <!-- Start content-list-row div -->
      <div class="content-list-row employment-outcome-row"
        *ngFor="let outcome of editor.employmentOutcomes; let i = index; trackBy: trackByIndex">

        <!-- Start label -->
        <label class="employment-outcome-label">
          Job role {{ i + 1 }}
        </label>
        <!-- End label -->

        <!-- Start input -->
        <input class="employment-outcome-input" [(ngModel)]="editor.employmentOutcomes[i]" maxlength="200"
          placeholder="Enter a job role">
        <!-- End input -->

        <!-- Start icon-button button -->
        <button type="button" class="icon-button danger employment-outcome-delete" (click)="removeOutcome(i)"
          [attr.aria-label]="'Remove outcome ' + (i + 1)">

          <!-- Start fa i -->
          <i class="fa fa-trash-o" aria-hidden="true"></i>
          <!-- End fa i -->

        </button>
        <!-- End icon-button button -->

      </div>
      <!-- End content-list-row div -->

      <!-- Start button-secondary button -->
      <button type="button" class="button-secondary compact" style="margin-top: 5px;" (click)="addOutcome()">
        <!-- Start fa i -->
        <i class="fa fa-plus" aria-hidden="true">
        </i>
        <!-- End fa i -->
        Add outcome
      </button>
      <!-- End button-secondary button -->

      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action content-section-heading">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Pathways to further study</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Select an existing course. The public page automatically shows its course code and name and links to that
            course detail page.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addPathway()">
          <!-- Start fa i -->
          <i class="fa fa-plus" aria-hidden="true">
          </i>
          <!-- End fa i -->
          Add pathway
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.studyPathways?.length">No study pathways added.</div>
      <!-- End empty-panel div -->
      <!-- Start content-list-row div -->
      <div class="content-list-row pathway-row" *ngFor="let pathway of editor.studyPathways; let i = index">
        <!-- Start full-width label -->
        <label class="full-width">
          Further-study course
          <!-- Start select -->
          <select [ngModel]="pathway.relatedCourseId" (ngModelChange)="onPathwayCourseSelected(pathway, $event)">
            <!-- Start option -->
            <option [ngValue]="0" disabled>Select a course</option>
            <!-- End option -->
            <!-- Start option -->
            <option *ngFor="let option of pathwayCourseCandidates" [ngValue]="option.courseId">{{ option.courseCode ?
              option.courseCode + ' - ' : '' }}{{ option.courseName }}</option>
            <!-- End option -->
          </select>
          <!-- End select -->
          <!-- Start small -->
          <small *ngIf="pathway.relatedCourseId && pathway.courseName">Public link: {{ pathway.courseCode ?
            pathway.courseCode + ' - ' : '' }}{{ pathway.courseName }}</small>
          <!-- End small -->
        </label>
        <!-- End full-width label -->
        <!-- Start icon-button button -->
        <button type="button" class="icon-button danger" (click)="removePathway(i)"
          [attr.aria-label]="'Remove pathway ' + (i + 1)">
          <!-- Start fa i -->
          <i class="fa fa-trash-o" aria-hidden="true">
          </i>
          <!-- End fa i -->
        </button>
        <!-- End icon-button button -->
      </div>
      <!-- End content-list-row div -->

      <!-- Start button-secondary button -->
      <button type="button" class="button-secondary compact" style="margin-top: 5px;" (click)="addPathway()">
        <!-- Start fa i -->
        <i class="fa fa-plus" aria-hidden="true">
        </i>
        <!-- End fa i -->
        Add pathway
      </button>
      <!-- End button-secondary button -->

      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action content-section-heading">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>Units of study</h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>Core and elective units appear as separate tables on the course page.</p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addCourseUnit()">
          <!-- Start fa i -->
          <i class="fa fa-plus" aria-hidden="true">
          </i>
          <!-- End fa i -->
          Add unit
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.courseUnits?.length">Add the units included in this course.</div>
      <!-- End empty-panel div -->
      <!-- Start study-unit-editor div -->
      <div class="study-unit-editor study-unit-row" *ngFor="let unit of editor.courseUnits; let i = index">
        <label class="unit-code-field">
          Unit code
          <input [(ngModel)]="unit.code" maxlength="50" placeholder="Unit code">
        </label>

        <label class="unit-type-field">
          Type
          <select [(ngModel)]="unit.unitType">
            <option value="core">Core</option>
            <option value="elective">Elective</option>
          </select>
        </label>

        <label class="unit-name-field">
          Unit name
          <input [(ngModel)]="unit.name" maxlength="200" placeholder="Unit name"
            [class.field-invalid]="!unit.name?.trim()">
        </label>

        <label class="checkbox-label unit-visible-field">
          <input type="checkbox" [(ngModel)]="unit.isActive">
          Visible on course page
        </label>

        <div class="study-unit-actions unit-row-actions">
          <button type="button" class="icon-button" [disabled]="i === 0" (click)="moveStudyUnit(i, -1)"
            [attr.aria-label]="'Move unit ' + (i + 1) + ' up'">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
          </button>

          <button type="button" class="icon-button" [disabled]="i === editor.courseUnits.length - 1"
            (click)="moveStudyUnit(i, 1)" [attr.aria-label]="'Move unit ' + (i + 1) + ' down'">
            <i class="fa fa-arrow-down" aria-hidden="true"></i>
          </button>

          <button type="button" class="icon-button danger" (click)="removeCourseUnit(i)"
            [attr.aria-label]="'Remove study unit ' + (i + 1)">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <!-- End study-unit-editor div -->

      <!-- Start button-secondary button -->
      <button type="button" class="button-secondary compact" style="margin-top: 5px;" (click)="addCourseUnit()">
        <!-- Start fa i -->
        <i class="fa fa-plus" aria-hidden="true">
        </i>
        <!-- End fa i -->
        Add unit
      </button>
      <!-- End button-secondary button -->
    </section>
    <!-- End editor-section section -->
    <!-- Start editor-section section -->
    <section *ngIf="editorTab === 'sessions'" class="editor-section">
      <!-- Start cluster-conversion-note div -->
      <div class="cluster-conversion-note" *ngIf="editor.isCluster">
        <!-- Start fa i -->
        <i class="fa fa-info-circle" aria-hidden="true">
        </i>
        <!-- End fa i -->
        <!-- Start div -->
        <div>
          <!-- Start strong -->
          <strong>Sessions are preserved during conversion</strong>
          <!-- End strong -->
          <!-- Start span -->
          <span>The sessions already attached to this CourseId remain available when changing between Individual and
            Training Cluster.</span>
          <!-- End span -->
        </div>
        <!-- End div -->
      </div>
      <!-- End cluster-conversion-note div -->
      <!-- Start section-heading div -->
      <div class="section-heading heading-with-action">
        <!-- Start div -->
        <div>
          <!-- Start h3 -->
          <h3>
            Available sessions
            <!-- Optional field -->
          </h3>
          <!-- End h3 -->
          <!-- Start p -->
          <p>
            {{ editor.isCluster ?
            'Existing sessions remain attached to this course and can still be maintained here.' :
            'Customers choose one of these sessions when booking.' }}
          </p>
          <!-- End p -->
        </div>
        <!-- End div -->
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary compact" (click)="addCourseTime()">
          <!-- Start fa i -->
          <i class="fa fa-plus" aria-hidden="true">
          </i>
          <!-- End fa i -->
          Add session
        </button>
        <!-- End button-secondary button -->
      </div>
      <!-- End section-heading div -->
      <!-- Start empty-panel div -->
      <div class="empty-panel" *ngIf="!editor.courseTimes?.length">No sessions yet. Add at least one training session.
      </div>
      <!-- End empty-panel div -->
      <!-- Start session-editor div -->
      <div class="session-editor" *ngFor="let time of editor.courseTimes; let i = index">
        <!-- Start session-editor-heading div -->
        <div class="session-editor-heading">
          <!-- Start strong -->
          <strong>
            <!-- Start fa i -->
            <i class="fa fa-calendar-o" aria-hidden="true">
            </i>
            <!-- End fa i -->
            Session {{ i + 1 }}
          </strong>
          <!-- End strong -->
          <!-- Start div -->
          <div>
            <!-- Start checkbox-label label -->
            <label class="checkbox-label">
              <!-- Start input -->
              <input type="checkbox" [(ngModel)]="time.isActive">
              <!-- End input -->
              Active
            </label>
            <!-- End checkbox-label label -->
            <!-- Start icon-button button -->
            <button type="button" class="icon-button danger" (click)="removeCourseTime(i)"
              [attr.aria-label]="'Remove session ' + (i + 1)">
              <!-- Start fa i -->
              <i class="fa fa-trash-o" aria-hidden="true">
              </i>
              <!-- End fa i -->
            </button>
            <!-- End icon-button button -->
          </div>
          <!-- End div -->
        </div>
        <!-- End session-editor-heading div -->
        <!-- Start field-grid div -->
        <div class="field-grid four-columns">
          <!-- Start label -->
          <label>
            Start date
            <!-- Start input -->
            <input type="date" [(ngModel)]="time.startDate" (change)="syncDateRange(time)">
            <!-- End input -->
          </label>
          <!-- End label -->
          <!-- Start label -->
          <label>
            End date
            <!-- Start input -->
            <input type="date" [(ngModel)]="time.endDate" (change)="syncDateRange(time)">
            <!-- End input -->
          </label>
          <!-- End label -->
          <!-- Start label -->
          <label>
            Time
            <!-- Start input -->
            <input [(ngModel)]="time.time" placeholder="8:30 AM - 4:30 PM">
            <!-- End input -->
          </label>
          <!-- End label -->
          <!-- Start label -->
          <label>
            Available seats
            <!-- Start input -->
            <input type="number" min="0" step="1" [(ngModel)]="time.seatsAvailable">
            <!-- End input -->
          </label>
          <!-- End label -->
        </div>
        <!-- End field-grid div -->
        <!-- Start field-grid div -->
        <div class="field-grid three-columns">
          <!-- Start label -->
          <label>
            Date range label
            <!-- Start input -->
            <input [(ngModel)]="time.dateRange">
            <!-- End input -->
          </label>
          <!-- End label -->
          <!-- Start label -->
          <label>
            Location
            <!-- Start input -->
            <input [(ngModel)]="time.locationName">
            <!-- End input -->
          </label>
          <!-- End label -->
          <!-- Start label -->
          <label>
            Delivery mode
            <!-- Start input -->
            <input [(ngModel)]="time.deliveryMode">
            <!-- End input -->
          </label>
          <!-- End label -->
        </div>
        <!-- End field-grid div -->
      </div>
      <!-- End session-editor div -->

    </section>
    <!-- End editor-section section -->
  </div>
  <!-- End editor-body div -->
  <!-- Start ng-template -->
  <ng-template pTemplate="footer">
    <!-- Start editor-footer div -->
    <div class="editor-footer">
      <!-- Start span -->
      <span>
        <!-- Start fa i -->
        <i class="fa fa-info-circle" aria-hidden="true">
        </i>
        <!-- End fa i -->
        Fields marked
        <!-- Start b -->
        <b>*</b>
        <!-- End b -->
        are required.
      </span>
      <!-- End span -->
      <!-- Start div -->
      <div>
        <!-- Start button-secondary button -->
        <button type="button" class="button-secondary" [disabled]="isSaving" (click)="showDialog=false">Cancel</button>
        <!-- End button-secondary button -->
        <!-- Start button-primary button -->
        <button type="button" class="button-primary" [disabled]="isSaving" (click)="save()">
          <!-- Start fa i -->
          <i class="fa" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true">
          </i>
          <!-- End fa i -->
          {{ isSaving ? 'Saving...' : (editor.isCluster ? 'Save cluster' : 'Save course') }}
        </button>
        <!-- End button-primary button -->
      </div>
      <!-- End div -->
    </div>
    <!-- End editor-footer div -->
  </ng-template>
  <!-- End ng-template -->
</p-dialog>
<!-- End p-dialog -->

<!-- End admin-course-page section -->
<!-- Start p-dialog -->

<!-- =========================================================
     QUALIFICATIONS COURSE DELETE CONFIRMATION
========================================================= -->

<div class="ecb-delete-confirm-backdrop" *ngIf="pendingDeleteCourse" (click)="cancelDelete()">

  <div class="ecb-delete-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="qualification-delete-title"
    (click)="$event.stopPropagation()">

    <!-- Delete Icon -->
    <div class="ecb-delete-confirm-icon">
      <i class="bi bi-trash3"></i>
    </div>

    <!-- Confirmation Content -->
    <div class="ecb-delete-confirm-content">

      <div class="ecb-delete-confirm-eyebrow">
        DELETE QUALIFICATION
      </div>

      <h3 id="qualification-delete-title">
        Are you sure you want to delete this course?
      </h3>

      <!-- Selected Course -->
      <div class="ecb-delete-confirm-course" *ngIf="pendingDeleteCourse as course">

        <strong>
          {{ course.courseCode }}
        </strong>

        <span>
          {{ course.courseName }}
        </span>

      </div>

      <!-- Description -->
      <p>
        This will remove the qualification from the
        admin and public course lists.

        The course record will be retained in the
        database but marked as deleted.
      </p>

      <!-- Warning -->
      <div class="ecb-delete-confirm-warning">

        <i class="bi bi-exclamation-triangle-fill"></i>

        <span>
          This action cannot be undone from the admin dashboard.
        </span>

      </div>

    </div>

    <!-- Action Buttons -->
    <div class="ecb-delete-confirm-actions">

      <button type="button" class="ecb-delete-cancel-button" (click)="cancelDelete()">

        Cancel

      </button>

      <button type="button" class="ecb-delete-confirm-button" (click)="confirmDelete()">

        <i class="bi bi-trash3"></i>

        Delete Course

      </button>

    </div>

  </div>

</div>

<!-- End p-dialog -->
<!-- Start p-dialog -->
<p-dialog [(visible)]="showMessageDialog" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '450px', maxWidth: '94vw' }" styleClass="admin-message-dialog">
  <!-- Start ng-template -->
  <ng-template pTemplate="header">
    <!-- Start confirm-dialog-heading div -->
    <div class="confirm-dialog-heading">
      <!-- Start confirm-dialog-icon span -->
      <span class="confirm-dialog-icon" [class.danger]="messageDialogType === 'error'"
        [class.success]="messageDialogType === 'success'">
        <!-- Start fa i -->
        <i class="fa"
          [ngClass]="messageDialogType === 'error' ? 'fa-exclamation-triangle' : (messageDialogType === 'success' ? 'fa-check' : 'fa-info-circle')"
          aria-hidden="true">
        </i>
        <!-- End fa i -->
      </span>
      <!-- End confirm-dialog-icon span -->
      <!-- Start div -->
      <div>
        <!-- Start page-eyebrow span -->
        <span class="page-eyebrow">{{ messageDialogType === 'error' ? 'ACTION FAILED' : (messageDialogType === 'success'
          ? 'COMPLETED' : 'INFORMATION') }}</span>
        <!-- End page-eyebrow span -->
        <!-- Start h3 -->
        <h3>{{ messageDialogTitle }}</h3>
        <!-- End h3 -->
      </div>
      <!-- End div -->
    </div>
    <!-- End confirm-dialog-heading div -->
  </ng-template>
  <!-- End ng-template -->
  <!-- Start confirm-dialog-body div -->
  <div class="confirm-dialog-body">
    <!-- Start p -->
    <p>{{ messageDialogText }}</p>
    <!-- End p -->
  </div>
  <!-- End confirm-dialog-body div -->
  <!-- Start ng-template -->
  <ng-template pTemplate="footer">
    <!-- Start confirm-dialog-actions div -->
    <div class="confirm-dialog-actions">
      <!-- Start button-primary button -->
      <button type="button" class="button-primary" (click)="showMessageDialog = false">OK</button>
      <!-- End button-primary button -->
    </div>
    <!-- End confirm-dialog-actions div -->
  </ng-template>
  <!-- End ng-template -->
</p-dialog>
<!-- End p-dialog -->






<!-- Course Download Dialog -->
<p-dialog header="Download Courses" [(visible)]="showDownloadDialog" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '440px', maxWidth: '95vw' }" styleClass="ecb-course-download-dialog">

  <div class="ecb-download-content">

    <!-- Course Type -->
    <div class="ecb-download-section">

      <label class="ecb-download-label">
        Select Course Type
      </label>

      <div class="ecb-download-radio-group">

        <div class="ecb-download-option">
          <p-radioButton name="downloadCourseType" value="ALL" [(ngModel)]="downloadCourseType" inputId="downloadAll">
          </p-radioButton>

          <label for="downloadAll">
            All Courses
          </label>
        </div>

        <div class="ecb-download-option">
          <p-radioButton name="downloadCourseType" value="SHORT" [(ngModel)]="downloadCourseType"
            inputId="downloadShort">
          </p-radioButton>

          <label for="downloadShort">
            Short Courses
          </label>
        </div>

        <div class="ecb-download-option">
          <p-radioButton name="downloadCourseType" value="LONG" [(ngModel)]="downloadCourseType" inputId="downloadLong">
          </p-radioButton>

          <label for="downloadLong">
            Long Courses
          </label>
        </div>

      </div>

    </div>

    <!-- Description Options -->
    <div class="ecb-download-section">

      <label class="ecb-download-label">
        Include Descriptions
      </label>

      <div class="ecb-download-checkbox-group">

        <div class="ecb-download-option">
          <p-checkbox [(ngModel)]="downloadShortDescription" [binary]="true" inputId="downloadShortDesc">
          </p-checkbox>

          <label for="downloadShortDesc">
            Short Description
          </label>
        </div>

        <div class="ecb-download-option">
          <p-checkbox [(ngModel)]="downloadDescription" [binary]="true" inputId="downloadFullDesc">
          </p-checkbox>

          <label for="downloadFullDesc">
            Full Description
          </label>
        </div>

      </div>

    </div>

  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">

    <button type="button" class="ecb-download-cancel-btn" [disabled]="isDownloading"
      (click)="showDownloadDialog = false">
      Cancel
    </button>

    <button type="button" class="ecb-x-admin-download-button" [disabled]="isDownloading"
      (click)="downloadCourseExcel()">

      <i class="bi" [ngClass]="isDownloading
                    ? 'bi-arrow-repeat'
                    : 'bi-file-earmark-excel'">
      </i>

      {{ isDownloading ? 'Preparing...' : 'Download Excel' }}

    </button>

  </ng-template>

</p-dialog>